import React from 'react';
import FileConvertSvg from '../assets/file-convert.svg';

const Logo = ({ size = 'medium', showText = true, variant = 'default' }) => {
  const sizes = {
    small: { width: 32, height: 32, fontSize: '12px' },
    medium: { width: 48, height: 48, fontSize: '16px' },
    large: { width: 64, height: 64, fontSize: '20px' }
  };

  const currentSize = sizes[size];

  // Color variants based on button state
  const colorVariants = {
    default: {
      primary: '#2196f3',
      secondary: '#1976d2',
      text: '#2196f3',
      subtext: '#666'
    },
    hover: {
      primary: '#1976d2',
      secondary: '#1565c0',
      text: '#1976d2',
      subtext: '#555'
    },
    active: {
      primary: '#1565c0',
      secondary: '#0d47a1',
      text: '#1565c0',
      subtext: '#444'
    },
    disabled: {
      primary: '#90caf9',
      secondary: '#bbdefb',
      text: '#90caf9',
      subtext: '#999'
    }
  };

  const colors = colorVariants[variant] || colorVariants.default;

  return (
    <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <img
        src={FileConvertSvg}
        alt="FileConvertHub Logo"
        width={currentSize.width}
        height={currentSize.height}
        style={{ 
          flexShrink: 0,
          filter: `drop-shadow(0 4px 6px rgba(0,0,0,0.2)) brightness(${variant === 'disabled' ? '0.7' : '1'}) saturate(${variant === 'disabled' ? '0.5' : '1'})`
        }}
      />
      
      {showText && (
        <div className="logo-text">
          <div 
            style={{
              fontSize: currentSize.fontSize,
              fontWeight: '700',
              color: colors.text,
              lineHeight: 1.2,
              letterSpacing: '-0.5px',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
            }}
          >
            FileConvertHub
          </div>
          <div 
            style={{
              fontSize: Math.floor(parseInt(currentSize.fontSize) * 0.6) + 'px',
              color: colors.subtext,
              fontWeight: '600',
              marginTop: '1px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
            }}
          >
            EPUB Converter
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
